import { Table } from 'antd';
import React from 'react';

export function DiffTable(props) {
  const { versions } = props;

  /**
   * Uses the record's highlight vlue along with the column
   * name to determine table cell background color.
   * @param {*} record
   * @param {*} col
   */
  const getColor = (record, col) => {
    let color = 'white';

    if (record.highlight.includes('driving') || record.highlight.includes('value')) {
      color = '#FFFFBB';
    } else if (record.highlight === 'added') {
      color = '#BFFFBB';
    } else if (record.highlight === 'deleted') {
      color = '#FFBBBB';
    }

    if (col === 'path') {
      return record.highlight === 'deleted' || record.highlight === 'added' ? color : 'white';
    }

    return record.highlight.includes(col) ||
      record.highlight === 'deleted' ||
      record.highlight === 'added'
      ? color
      : 'white';
  };

  const tableColumns = [
    {
      title: (
        <p>
          Path: <br /> {versions[1]}
        </p>
      ),
      dataIndex: ['latest', 'path'],
      width: '22.5%',
      editable: false,
      sorter: (a, b) => {
        if (a.latest.path === null || b.latest.path === null) return 1;
        return a.latest.path.localeCompare(b.latest.path);
      },
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'path'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{String(value)}</div>,
        };
      },
    },
    {
      title: (
        <p>
          Path: <br /> {versions[0]}
        </p>
      ),
      dataIndex: ['current', 'path'],
      width: '22.5%',
      editable: false,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => {
        if (a.current.path === null || b.current.path === null) return 1;
        return a.current.path.localeCompare(b.current.path);
      },
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'path'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{String(value)}</div>,
        };
      },
    },
    {
      title: (
        <p>
          Value: <br /> {versions[1]}
        </p>
      ),
      dataIndex: ['latest', 'value'],
      width: '22.5%',
      editable: false,
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'value'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{String(value)}</div>,
        };
      },
    },
    {
      title: (
        <p>
          Value: <br /> {versions[0]}
        </p>
      ),
      dataIndex: ['current', 'value'],
      width: '22.5%',
      editable: false,
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'value'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{String(value)}</div>,
        };
      },
    },
    {
      title: (
        <p>
          Driving: <br /> {versions[1]}
        </p>
      ),
      dataIndex: ['latest', 'driving'],
      editable: false,
      width: '5%',
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'driving'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{value}</div>,
        };
      },
    },
    {
      title: (
        <p>
          Driving: <br /> {versions[0]}
        </p>
      ),
      dataIndex: ['current', 'driving'],
      editable: false,
      width: '5%',
      render(value, record) {
        return {
          props: {
            style: {
              background: getColor(record, 'driving'),
            },
            className: 'virtual-table-cell-diff',
          },
          children: <div>{value}</div>,
        };
      },
    },
  ];

  const mergedColumns = tableColumns.map(column => {
    return {
      ...column,
      onCell: record => {
        return {
          record,
          editable: column.editable,
          dataIndex: column.dataIndex,
          title: column.title,
        };
      },
    };
  });

  return (
    <Table
      className="virtual-table-not-editable"
      columns={mergedColumns}
      loading={props.loading}
      rowKey={props.rowKey}
      scroll={{ x: 2000, y: 400 }}
      dataSource={props.dataSource}
      pagination={{ defaultPageSize: 100, size: 'small' }}
    />
  );
}

export default DiffTable;
